export default function (state, getters, rootState, rootGetters) {
    let data = {};
    if (!getters.form.ContragentId || !state.Sum) return;
    data.CertificateId = rootState.certificates.item.id;
    data.PaymentDirection = 0;
    data.Direction = 1;
    data.PaymentOperationID = state.PaymentOperationID;
    data.PaymentTypeId = state.PaymentTypeId;
    data.ContragentType = getters.form.ContragentType;
    data.ContragentID = getters.form.ContragentId;
    data.Sum = state.Sum;
    data.BankCommission = state.BankCommission;
    data.CurrencyId = getters.form.CurrencyId;
    data.Comment = state.Comment;
    if (getters.form.ContragentType === 2) {
        data.PartnerLegalEntityId = getters.form.PartnerLegalId;
    }

    switch (state.CategoryId) {
        case 0:
            data.CashId = state.CashId;
            break;
        case 1:
            data.PaymentAccountId = state.PaymentAccountId;
            break;
    }
    data.AccountNumber = state.AccountNumber;
    data.DocumentNumber = encodeURIComponent(state.DocumentNumber);
    data.PaymentDetails = state.PaymentDetails;
    data.PaymentDate = {"Serialized": state.PaymentDate, "Format": "dd.MM.yyyy"};
    if (state.Id && state.Id !== -1) data.Id = state.Id;
    return data;
}